import { getClient } from '@/api/client';
import { useState, useEffect } from 'react';

const useClientById = (id: string) => {
  const [client, setClient] = useState<Client | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchClient = async () => {
      try {
        // Make an API call to fetch Clients
        const response = await getClient(id);

        setClient(response);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching client:', error);
        setLoading(false);
      }
    };

    fetchClient();
  }, [id]);

  return { ...client, loading };
};

export default useClientById;
